module.exports = __webpack_public_path__ + "static/media/06_CORTININHA_SEM_BOJO_LISO_01.c652b91d.jpg";